<template>
  <router-link
    :to="{ name: toRouteName }"
    :event="''"
    @click.native="handleClick"
    :class="className"
  >
    <slot/>
  </router-link>
</template>

<script>
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';

export default {
  name: 'ToggleRouterLink',
  props: {
    toRouteName: String,
    fromRouteName: { type: String, default: 'order' },
    routeParams: { type: Object, default: () => ({}) },
    className: { type: String, default: 'btn btn-default' },
    redirectCondition: { default: true },
    errorMessage: { default: '' },
  },
  methods: {
    handleClick() {
      if (this.$router.currentRoute.name === this.toRouteName) {
        this.$emit('click');
        return this.$router.push({ name: this.fromRouteName });
      }
      if(typeof(this.redirectCondition) == 'boolean' || this.redirectCondition === null) {
        if (this.redirectCondition) {
          return this.$router.push({ name: this.toRouteName, params: this.routeParams });
        }
        return this.$store.commit(SET_MESSAGE_MODAL, this.errorMessage);
      } else if (typeof(this.redirectCondition) == 'object') {
        if(Array.isArray(this.redirectCondition)) {
          let failAt = null;
          this.redirectCondition.forEach((condition, index) => {
            if(failAt == null && !condition) {
              failAt = index;
            }
          });
          if(failAt != null) {
            return this.$store.commit(SET_MESSAGE_MODAL, this.$gettext(this.errorMessage[failAt]));
          } else {
            return this.$router.push({ name: this.toRouteName, params: this.routeParams });
          }
        }
        return this.$router.push({ name: this.toRouteName, params: this.routeParams });
      }
    },
  },
};
</script>
